export default __webpack_public_path__ + "media/images/Collapse_Left-89e4911eb291328fd8a858ae62479e74.png";